import React from 'react';

import taynguyen from '../img/den/taynguyen.png';

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <h1 className="hero-title">Thư Giãn Với Hương Thơm Tự Nhiên</h1>
        <p className="hero-subtitle">
          Đèn xông tinh dầu mang đến sự thư giãn sâu lắng, giúp cân bằng tinh thần và nâng tầm không gian sống của bạn.
        </p>
        <button className="cta-button" onClick={() => scrollTo('products')}>Mua Ngay</button>
      </div>
      <div className="hero-image">
        <div className="image-circle top-circle"></div>
        <div className="image-circle bottom-circle"></div>
        <img src={taynguyen} alt="Đèn xông tinh dầu" className="hero-img" />
      </div>
    </section>
  );
};

export default Hero;
